import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NavbarCapacita.css';
import Logo from "../../components/logo/Logo";
import { FaBars } from 'react-icons/fa';
import LogoMobile from '../logo/LogoMobile';

const NavbarCapacita = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem("site");
        navigate("/login");
    };

    return (
        <div className="navbar">
            <div className="logo-container">
                <Logo />
            </div>
            <div className="nav-buttons-container">
                {isMobile ? (
                    <button className={`navbar-toggle ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                      {menuOpen ? <FaBars /> : <FaBars />}
                  </button>
                ) : (
                    <div className="nav-buttons">
                        <Link to="/home" className="nav-button inicio">INICIO</Link>
                        <Link to="/training" className="nav-button capacitaciones">CAPACITACIONES</Link>
                        <Link to="/evaluation" className="nav-button evaluacion">EVALUACIÓN</Link>
                        <button onClick={handleLogout} className="nav-button cerrar-sesion">CERRAR SESIÓN</button>
                    </div>
                )}
            </div>

            {isMobile && menuOpen && (
                <div className="mobile-menu">
                  <div className="logo-container">
                  {isMobile && menuOpen ? (
                      <LogoMobile />
                  ) : (
                      <Logo />
                  )}
                  </div>
                  <ul className="mobile-menu-list">
                      <li className="mobile-menu-item">
                          <Link to="/home" className="mobile-menu-link" onClick={toggleMenu}>INICIO</Link>
                      </li>
                      <li className="mobile-menu-item">
                          <Link to="/training" className="mobile-menu-link" onClick={toggleMenu}>CAPACITACIONES</Link>
                      </li>
                      <li className="mobile-menu-item">
                          <Link to="/evaluation" className="mobile-menu-link" onClick={toggleMenu}>EVALUACIÓN</Link>
                      </li>
                      <li className="mobile-menu-item">
                          <button onClick={() => { handleLogout(); toggleMenu(); }} className="mobile-menu-link">CERRAR SESIÓN</button>
                      </li>
                  </ul>
                </div>
            )}
        </div>
    );
}

export default NavbarCapacita;